export const DEFAULT_SAVE_STATUS = {
  lastSavedQuestions: [],
  retrying: false,
  saveFailedQuestions: [],
  savingBlocks: [],
};

export const DATASHEET_FILTER_TAG = {
  ALL: 'All',
  NOTE_EXISTED: 'Note',
  ACTION_NEEDED: 'Negative outcome',
  NEGATIVE_OUTCOME: 'With Negative outcome'
};

export const DEFAULT_SMILEY_RATING = [
  'happiness-angry',
  'happiness-sad',
  'happiness-ok',
  'happiness-happy',
  'happiness-very-happy'
];